import { useTranslations } from 'next-intl';
import React from 'react';

import { Icon } from '@components/icons';
import { Link } from '@lib/navigation';

const SuccessTitle = ({ isConfirmed, email }: { isConfirmed: boolean, email: string }) => {
  const t = useTranslations('auth.registerV2');
  const finishSubtitle = isConfirmed ? t('finishSubtitle.confirmed', { email }) : t('finishSubtitle.created', { email });

  return (
    <>
      <h1 className="text-2xl mb-4 font-bold">{t('congratulations')}</h1>
      <p className="flex items-start justify-center mt-4 font-bold">
        <Icon icon='check-filled' className='min-w-[20px] mr-2 text-green-light dark:text-white' size={20} />
        {finishSubtitle}
      </p>
    </>
  );
}
const FailureTitle = ({ isConfirmed, email }: { isConfirmed: boolean, email: string }) => {
  const t = useTranslations('auth.registerV2');
  const failureSubtitle = isConfirmed ? t('failureSubtitle.confirmed', { email }) : t('failureSubtitle.created', { email });

  return (<>
    <h1 className="text-2xl mb-4 font-bold">{t('failure')}</h1>
    <p className="flex items-start justify-center mt-4 font-bold">
      <Icon icon='forbidden' className='min-w-[20px] mr-2 text-red' size={20} />
      {failureSubtitle}
    </p>
  </>
  );
}
const FailureText = ({ isConfirmed }: { isConfirmed: boolean }) => {
  const t = useTranslations('auth.registerV2');
  if (isConfirmed) {
    return <div className='max-w-[360px] mx-auto text-left my-4'>
      <p className='mb-2'>{t('failureConfirmText1')}</p>
      <p>{t('failureConfirmText2')}</p>
    </div>
  }
  return (
    <div className='max-w-[300px] mx-auto text-left my-4'>
      <p>
        {t('failureCreateText')}
      </p>
    </div>
  );
}

const SuccessText = ({ isConfirmed, isShort }: { isConfirmed: boolean, isShort: boolean }) => {
  const t = useTranslations('auth.registerV2');
  if (isConfirmed) {
    return;
  }
  return <>
    <div className='text-center mt-4 font-bold'>
      {t('whatNow')}
    </div>
    <div className='flex flex-row mt-1 max-w-[300px] mx-auto'>
      <Icon className='min-w-[20px]' icon='forbidden' color="#a8a8a8" size={20} />
      <div className='text-left pl-2'>
        <p className='mb-4'>{isShort ? t('confirmEmailAndPassNow') : t('confirmEmailNow')}</p>
        <p className='text-[14px] opacity-[0.3] dark:opacity-[0.7]'>{t('checkSpam')}</p>
      </div>
    </div>
  </>
}

const FinishRegistrationV2 = ({ isConfirmed, isSuccess, isShort, email, redirectUrl }: { isConfirmed: boolean, isShort: boolean, isSuccess?: boolean, email: string, redirectUrl: string }) => {
  const t = useTranslations('auth.registerV2');
  return (
    <div className="text-center text-premium-dark dark:text-white">
      {isSuccess && <>
        <SuccessTitle isConfirmed={isConfirmed} email={email} />
        <SuccessText isConfirmed={isConfirmed} isShort={isShort} />
      </>}
      {!isSuccess && <>
        {!isSuccess && <FailureTitle isConfirmed={isConfirmed} email={email} />}
        {!isSuccess && <FailureText isConfirmed={isConfirmed} />}
      </>}
      {redirectUrl && (
        <Link href={redirectUrl || ''} className="inline-block bg-premium-dark text-white dark:bg-white dark:border dark:text-premium-dark p-4 px-8 mt-8 rounded-full hover:text-white hover:bg-blue">
          {t('continue')}
        </Link>
      )}
    </div>
  );
};

export default FinishRegistrationV2;